// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.offerDetailsMainDiv {
    width: 75%;
    margin-left: 36px;
}

.offerDetailsFlexDiv {
    display: flex;
    align-items: center;
}

.offerDetailsFieldTitle.MuiTypography-root {
    font-family: "Poppins";
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 18px;
    color: var(--Global-Neutral-Grey-1100, #2D2B32);
}

.offerCheckboxLabel .MuiFormControlLabel-root {
    margin-left: 0px;
}

.offerCheckbox .MuiSvgIcon-root {
    height: 16px !important;
    width: 16px !important;
}

.offerCheckboxText .MuiFormControlLabel-root .MuiFormControlLabel-label {
    color: var(--Global-Neutral-Grey-1000, #4F4D55);
    font-family: Poppins;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    margin-left: 8px;
}

.offerDateateField .MuiFormControl-root.MuiTextField-root {
    margin-top: 8px;
}


.offerDetailsFieldWidth .MuiInputBase-root {
    width: auto !important;
}

.offerDetailsFieldWidth .MuiFormControl-root.MuiTextField-root {
    width: 100%;
}

.selectbackground .MuiSelect-select.MuiInputBase-input.MuiOutlinedInput-input {
    width: 85px;
}

.amountFieldRadius .MuiInputBase-root.MuiOutlinedInput-root {
    border-radius: 0px 4px 4px 0px !important;
}

.currencyDropdownRadius .css-1yk1gt9-MuiInputBase-root-MuiOutlinedInput-root-MuiSelect-root {
    border-radius: 4px 0px 0px 4px !important;
}

.ql-container.ql-snow {
    border: 0px !important;
    border-radius: 0px 0px 8px 8px !important;
    min-height: 100px !important;
    height: 80px;
    overflow-x: hidden;
    overflow-y: scroll;
}

.ql-toolbar.ql-snow {
    background: var(--Global-Neutral-Grey-200, #F8F8F8) !important;
    border-radius: 0px 0px 8px 8px !important;
}

.ql-snow * {
    font-family: Poppins !important;
    font-size: 14px;
}


.offerTitleTooltip .MuiSvgIcon-root {
    height: 14px !important;
    width: 14px !important;
    margin: 0px 6px;
}

.offerTitleTooltip .MuiButtonBase-root.MuiIconButton-root {
    padding: 0px !important;
    margin-bottom: 8px;
}


.textfieldMarginBottom.MuiTypography-root {
    margin-bottom: 8px;
}

.dateFieldDiv {
    display: flex;
    margin-top: 28px;
    width: 100%
}

.startDateField {
    flex-basis: 50%;
    padding-right: 1rem;
}

.endDateField {
    flex-basis: 50%;
    padding-left: 1rem;
}

.checkboxDiv {
    display: flex;
    align-items: center;
    margin-top: 8px;
    gap: 8px
}

.amountCurrencyField {
    display: flex !important;
    flex-direction: row !important;
    align-items: center;
    width: 100%
}

.termsAndConditionDiv {
    margin-top: 28px;
}

.richTextEditior {
    margin-top: 8px;
    width: 100%;
    min-height: 150px;
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    display: flex;
    flex-direction: column-reverse
}

.currencyTextDiv {
    border: 1px solid #bbbbbb;
    height: 40px;
    display: flex;
    align-items: center;
    padding: 18px;
    border-radius: 4px 0px 0px 4px;
    background-color: var(--Neutral-2, #FAFAFA);
}

.error-msz-text {
    font-weight: 400;
    font-size: 0.75rem;
    line-height: 1.66;
    letter-spacing: 0.03333em;
    text-align: left;
    margin: 4px 14px 0px;
    color: rgb(211, 47, 47) !important;
}

.error-msz-text.hidden {
    opacity: 0;
    visibility: hidden;
}

.error-msz-text.visible {
    opacity: 1;
    visibility: visible;
}

.offerDetailsMainDiv .ql-editor.ql-blank::before {
    font-style: normal !important;
}`, "",{"version":3,"sources":["webpack://./src/components/reusableComponents/offerManagement/offerDetails/OfferDetails.css"],"names":[],"mappings":"AAAA;IACI,UAAU;IACV,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,sBAAsB;IACtB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,+CAA+C;AACnD;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,uBAAuB;IACvB,sBAAsB;AAC1B;;AAEA;IACI,+CAA+C;IAC/C,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB;;;AAGA;IACI,sBAAsB;AAC1B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,sBAAsB;IACtB,yCAAyC;IACzC,4BAA4B;IAC5B,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,8DAA8D;IAC9D,yCAAyC;AAC7C;;AAEA;IACI,+BAA+B;IAC/B,eAAe;AACnB;;;AAGA;IACI,uBAAuB;IACvB,sBAAsB;IACtB,eAAe;AACnB;;AAEA;IACI,uBAAuB;IACvB,kBAAkB;AACtB;;;AAGA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB;AACJ;;AAEA;IACI,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf;AACJ;;AAEA;IACI,wBAAwB;IACxB,8BAA8B;IAC9B,mBAAmB;IACnB;AACJ;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb;AACJ;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,aAAa;IACb,8BAA8B;IAC9B,2CAA2C;AAC/C;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;IACjB,yBAAyB;IACzB,gBAAgB;IAChB,oBAAoB;IACpB,kCAAkC;AACtC;;AAEA;IACI,UAAU;IACV,kBAAkB;AACtB;;AAEA;IACI,UAAU;IACV,mBAAmB;AACvB;;AAEA;IACI,6BAA6B;AACjC","sourcesContent":[".offerDetailsMainDiv {\n    width: 75%;\n    margin-left: 36px;\n}\n\n.offerDetailsFlexDiv {\n    display: flex;\n    align-items: center;\n}\n\n.offerDetailsFieldTitle.MuiTypography-root {\n    font-family: \"Poppins\";\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 18px;\n    color: var(--Global-Neutral-Grey-1100, #2D2B32);\n}\n\n.offerCheckboxLabel .MuiFormControlLabel-root {\n    margin-left: 0px;\n}\n\n.offerCheckbox .MuiSvgIcon-root {\n    height: 16px !important;\n    width: 16px !important;\n}\n\n.offerCheckboxText .MuiFormControlLabel-root .MuiFormControlLabel-label {\n    color: var(--Global-Neutral-Grey-1000, #4F4D55);\n    font-family: Poppins;\n    font-size: 12px;\n    font-style: normal;\n    font-weight: 400;\n    margin-left: 8px;\n}\n\n.offerDateateField .MuiFormControl-root.MuiTextField-root {\n    margin-top: 8px;\n}\n\n\n.offerDetailsFieldWidth .MuiInputBase-root {\n    width: auto !important;\n}\n\n.offerDetailsFieldWidth .MuiFormControl-root.MuiTextField-root {\n    width: 100%;\n}\n\n.selectbackground .MuiSelect-select.MuiInputBase-input.MuiOutlinedInput-input {\n    width: 85px;\n}\n\n.amountFieldRadius .MuiInputBase-root.MuiOutlinedInput-root {\n    border-radius: 0px 4px 4px 0px !important;\n}\n\n.currencyDropdownRadius .css-1yk1gt9-MuiInputBase-root-MuiOutlinedInput-root-MuiSelect-root {\n    border-radius: 4px 0px 0px 4px !important;\n}\n\n.ql-container.ql-snow {\n    border: 0px !important;\n    border-radius: 0px 0px 8px 8px !important;\n    min-height: 100px !important;\n    height: 80px;\n    overflow-x: hidden;\n    overflow-y: scroll;\n}\n\n.ql-toolbar.ql-snow {\n    background: var(--Global-Neutral-Grey-200, #F8F8F8) !important;\n    border-radius: 0px 0px 8px 8px !important;\n}\n\n.ql-snow * {\n    font-family: Poppins !important;\n    font-size: 14px;\n}\n\n\n.offerTitleTooltip .MuiSvgIcon-root {\n    height: 14px !important;\n    width: 14px !important;\n    margin: 0px 6px;\n}\n\n.offerTitleTooltip .MuiButtonBase-root.MuiIconButton-root {\n    padding: 0px !important;\n    margin-bottom: 8px;\n}\n\n\n.textfieldMarginBottom.MuiTypography-root {\n    margin-bottom: 8px;\n}\n\n.dateFieldDiv {\n    display: flex;\n    margin-top: 28px;\n    width: 100%\n}\n\n.startDateField {\n    flex-basis: 50%;\n    padding-right: 1rem;\n}\n\n.endDateField {\n    flex-basis: 50%;\n    padding-left: 1rem;\n}\n\n.checkboxDiv {\n    display: flex;\n    align-items: center;\n    margin-top: 8px;\n    gap: 8px\n}\n\n.amountCurrencyField {\n    display: flex !important;\n    flex-direction: row !important;\n    align-items: center;\n    width: 100%\n}\n\n.termsAndConditionDiv {\n    margin-top: 28px;\n}\n\n.richTextEditior {\n    margin-top: 8px;\n    width: 100%;\n    min-height: 150px;\n    border: 1px solid #e0e0e0;\n    border-radius: 8px;\n    display: flex;\n    flex-direction: column-reverse\n}\n\n.currencyTextDiv {\n    border: 1px solid #bbbbbb;\n    height: 40px;\n    display: flex;\n    align-items: center;\n    padding: 18px;\n    border-radius: 4px 0px 0px 4px;\n    background-color: var(--Neutral-2, #FAFAFA);\n}\n\n.error-msz-text {\n    font-weight: 400;\n    font-size: 0.75rem;\n    line-height: 1.66;\n    letter-spacing: 0.03333em;\n    text-align: left;\n    margin: 4px 14px 0px;\n    color: rgb(211, 47, 47) !important;\n}\n\n.error-msz-text.hidden {\n    opacity: 0;\n    visibility: hidden;\n}\n\n.error-msz-text.visible {\n    opacity: 1;\n    visibility: visible;\n}\n\n.offerDetailsMainDiv .ql-editor.ql-blank::before {\n    font-style: normal !important;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
